<header [ngClass]="{'py-3 bg-dark-blue/80 backdrop-blur shadow-glow-sm': isScrolled, 'py-5': !isScrolled}"
        class="w-full transition-all duration-300">
  <div class="container mx-auto px-4 md:px-6">
    <div class="flex items-center justify-between">
      <!-- Logo -->
      <a class="flex items-center" href="#">
        <img alt="" class="h-8 w-auto" src="logo.webp">
        <!-- Animated AI Music Icon -->
        <div class="ml-2 flex items-center">
          <svg class="w-6 h-6" fill="none" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <!-- AI Brain outline -->
            <path class="ai-brain-footer"
                  d="M24 8c-6.627 0-12 5.373-12 12 0 1.5.3 3 .8 4.3L8 28c-1.1 0-2 .9-2 2s.9 2 2 2h4.8c1.5 2.5 4.1 4.3 7.2 4.8V40c0 1.1.9 2 2 2s2-.9 2-2v-3.2c3.1-.5 5.7-2.3 7.2-4.8H36c1.1 0 2-.9 2-2s-.9-2-2-2l-4.8-3.7c.5-1.3.8-2.8.8-4.3 0-6.627-5.373-12-12-12z"
                  fill="none" opacity="0.7" stroke="url(#headerGradient1)" stroke-width="2"/>

            <!-- Animated sound waves -->
            <g class="sound-waves-footer">
              <path class="wave-footer wave-footer-1" d="M24 2c2-2 2-4 0-6" fill="none"
                    stroke="url(#headerGradient2)" stroke-linecap="round" stroke-width="2"/>
              <path class="wave-footer wave-footer-2" d="M46 24c2-2 4-2 6 0" fill="none"
                    stroke="url(#headerGradient2)" stroke-linecap="round" stroke-width="2"/>
              <path class="wave-footer wave-footer-3" d="M24 46c-2 2-2 4 0 6" fill="none"
                    stroke="url(#headerGradient2)" stroke-linecap="round" stroke-width="2"/>
              <path class="wave-footer wave-footer-4" d="M2 24c-2 2-4 2-6 0" fill="none"
                    stroke="url(#headerGradient2)" stroke-linecap="round" stroke-width="2"/>
            </g>

            <!-- Musical notes -->
            <g class="musical-notes-footer">
              <circle class="note-footer note-footer-1" cx="39" cy="9" fill="url(#headerGradient3)" r="1.5"/>
              <circle class="note-footer note-footer-2" cx="39" cy="39" fill="url(#headerGradient3)" r="1.5"/>
              <circle class="note-footer note-footer-3" cx="9" cy="39" fill="url(#headerGradient3)" r="1.5"/>
              <circle class="note-footer note-footer-4" cx="9" cy="9" fill="url(#headerGradient3)" r="1.5"/>
            </g>

            <!-- Gradient definitions -->
            <defs>
              <linearGradient id="headerGradient1" x1="0%" x2="100%" y1="0%" y2="100%">
                <stop offset="0%" style="stop-color:#00a2ff"/>
                <stop offset="100%" style="stop-color:#ff0080"/>
              </linearGradient>
              <linearGradient id="headerGradient2" x1="0%" x2="100%" y1="0%" y2="0%">
                <stop offset="0%" style="stop-color:#00a2ff"/>
                <stop offset="100%" style="stop-color:#ff0080"/>
              </linearGradient>
              <linearGradient id="headerGradient3" x1="0%" x2="100%" y1="0%" y2="100%">
                <stop offset="0%" style="stop-color:#ff0080"/>
                <stop offset="100%" style="stop-color:#00a2ff"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
      </a>

      <!-- Desktop Navigation -->
      <nav class="hidden lg:flex items-center space-x-8">
        <a [class]="'text-sm font-medium transition-colors ' + (isActive('demo') ? 'text-white font-bold border-b-2 border-electric-blue' : 'text-white/80 hover:text-white')"
           href="#demo">Demo</a>
        <a [class]="'text-sm font-medium transition-colors ' + (isActive('how-it-works') ? 'text-white font-bold border-b-2 border-electric-blue' : 'text-white/80 hover:text-white')"
           href="#how-it-works">How It
          Works</a>
        <a [class]="'text-sm font-medium transition-colors ' + (isActive('pricing') ? 'text-white font-bold border-b-2 border-electric-blue' : 'text-white/80 hover:text-white')"
           href="#pricing">Pricing</a>
        <a [class]="'text-sm font-medium transition-colors ' + (isActive('why-us') ? 'text-white font-bold border-b-2 border-electric-blue' : 'text-white/80 hover:text-white')"
           href="#why-us">Why Us</a>
        <a [class]="'text-sm font-medium transition-colors ' + (isActive('song-hub') ? 'text-white font-bold border-b-2 border-electric-blue' : 'text-white/80 hover:text-white')"
           href="#song-hub">Song Hub</a>
        <!-- API Access Dropdown -->
        <div class="api-dropdown-container">
          <button (click)="toggleApiDropdown()"
                  class="text-sm text-white font-bold bg-gradient-to-r from-electric-blue to-magenta bg-clip-text text-transparent hover:opacity-80 transition-colors"
                  type="button">
            API
          </button>

          <div [class.show]="apiDropdownOpen" class="api-dropdown">
            <a class="dropdown-item" href="https://www.mypart.ai/api-access" target="_blank">
              <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="2"></path>
                <polyline points="22 4 12 14.01 9 11.01" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="2"></polyline>
              </svg>
              Request API Access
            </a>
            <a class="dropdown-item" href="https://api.mypart.com/" target="_blank">
              <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="2"></path>
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="2"></path>
              </svg>
              API for Developers
            </a>
          </div>
        </div>

        <!-- Normal/Gaming Mode Toggle (Hidden by default, shown after z-key detection) -->
        <div *ngIf="showToggle" class="gaming-mode-toggle">
          <div class="toggle-container">
            <span class="toggle-label">{{ isGamingMode ? 'Return to Normal Mode' : 'Activate Gaming Mode' }}</span>
            <div class="toggle-switch" [class.active]="isGamingMode" (click)="toggleGamingMode()">
              <div class="toggle-slider"></div>
            </div>
          </div>
        </div>
      </nav>

      <!-- Header Actions -->
      <div class="hidden lg:flex items-center gap-3">
        <!-- TODO: Re-enable when backend is ready for lead gen
        <button *ngIf="!isSignedUp()" (click)="openSignupPopup()"
                class="text-sm font-medium text-white/80 hover:text-white border border-white/20 hover:border-electric-blue/50 px-4 py-2 rounded-lg transition-all">
          Stay Updated
        </button> -->
        <a class="btn btn-primary" href="https://www.mypart.ai/contact" target="_blank">
          Contact Us
        </a>
      </div>

      <!-- Mobile Menu Button -->
      <div (click)="toggleMobileMenu()" [ngClass]="{'open': mobileMenuOpen}" class="lg:hidden hamburger-button">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <!-- Mobile Navigation Overlay -->
    <div [ngClass]="{'open !w-full': mobileMenuOpen}" class="mobile-menu-overlay flex lg:hidden w-0">
      <!-- Fixed top logo section -->
      <div class="mobile-header-fixed">
        <a class="flex items-center" href="#">
          <img alt="" class="h-8 w-auto" src="logo.webp">
          <!-- Animated AI Music Icon -->
          <div class="ml-2 flex items-center">
            <svg class="w-6 h-6" fill="none" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
              <!-- AI Brain outline -->
              <path class="ai-brain-footer"
                    d="M24 8c-6.627 0-12 5.373-12 12 0 1.5.3 3 .8 4.3L8 28c-1.1 0-2 .9-2 2s.9 2 2 2h4.8c1.5 2.5 4.1 4.3 7.2 4.8V40c0 1.1.9 2 2 2s2-.9 2-2v-3.2c3.1-.5 5.7-2.3 7.2-4.8H36c1.1 0 2-.9 2-2s-.9-2-2-2l-4.8-3.7c.5-1.3.8-2.8.8-4.3 0-6.627-5.373-12-12-12z"
                    fill="none" opacity="0.7" stroke="url(#mobileHeaderGradient1)" stroke-width="2"/>

              <!-- Animated sound waves -->
              <g class="sound-waves-footer">
                <path class="wave-footer wave-footer-1" d="M24 2c2-2 2-4 0-6" fill="none"
                      stroke="url(#mobileHeaderGradient2)" stroke-linecap="round" stroke-width="2"/>
                <path class="wave-footer wave-footer-2" d="M46 24c2-2 4-2 6 0" fill="none"
                      stroke="url(#mobileHeaderGradient2)" stroke-linecap="round" stroke-width="2"/>
                <path class="wave-footer wave-footer-3" d="M24 46c-2 2-2 4 0 6" fill="none"
                      stroke="url(#mobileHeaderGradient2)" stroke-linecap="round" stroke-width="2"/>
                <path class="wave-footer wave-footer-4" d="M2 24c-2 2-4 2-6 0" fill="none"
                      stroke="url(#mobileHeaderGradient2)" stroke-linecap="round" stroke-width="2"/>
              </g>

              <!-- Musical notes -->
              <g class="musical-notes-footer">
                <circle class="note-footer note-footer-1" cx="39" cy="9" fill="url(#mobileHeaderGradient3)" r="1.5"/>
                <circle class="note-footer note-footer-2" cx="39" cy="39" fill="url(#mobileHeaderGradient3)" r="1.5"/>
                <circle class="note-footer note-footer-3" cx="9" cy="39" fill="url(#mobileHeaderGradient3)" r="1.5"/>
                <circle class="note-footer note-footer-4" cx="9" cy="9" fill="url(#mobileHeaderGradient3)" r="1.5"/>
              </g>

              <!-- Gradient definitions -->
              <defs>
                <linearGradient id="mobileHeaderGradient1" x1="0%" x2="100%" y1="0%" y2="100%">
                  <stop offset="0%" style="stop-color:#00a2ff"/>
                  <stop offset="100%" style="stop-color:#ff0080"/>
                </linearGradient>
                <linearGradient id="mobileHeaderGradient2" x1="0%" x2="100%" y1="0%" y2="0%">
                  <stop offset="0%" style="stop-color:#00a2ff"/>
                  <stop offset="100%" style="stop-color:#ff0080"/>
                </linearGradient>
                <linearGradient id="mobileHeaderGradient3" x1="0%" x2="100%" y1="0%" y2="100%">
                  <stop offset="0%" style="stop-color:#ff0080"/>
                  <stop offset="100%" style="stop-color:#00a2ff"/>
                </linearGradient>
              </defs>
            </svg>
          </div>
        </a>
        <!--        <div class="close-button" (click)="closeMobileMenu()">-->
        <!--          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>-->
        <!--        </div>-->
      </div>

      <!-- Decorative elements -->
      <div class="menu-decoration top-right"></div>
      <div class="menu-decoration bottom-left"></div>

      <!-- Scrollable menu items container -->
      <div class="menu-scrollable">
        <div class="menu-items">
          <div [ngClass]="{'visible': mobileMenuOpen}" class="menu-item-container">
            <a (click)="closeMobileMenu()" [class]="'nav-item ' + (isActive('demo') ? 'active' : '')" href="#demo">
            <span class="nav-icon">
              <svg fill="none" height="20" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                   stroke-width="2" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path
                  d="M12 19l7-7 3 3-7 7-3-3z"></path><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"></path><path
                  d="M2 2l7.586 7.586"></path><circle cx="11" cy="11" r="2"></circle></svg>
            </span>
              Demo
            </a>
          </div>

          <div [ngClass]="{'visible': mobileMenuOpen}" class="menu-item-container">
            <a (click)="closeMobileMenu()" [class]="'nav-item ' + (isActive('how-it-works') ? 'active' : '')"
               href="#how-it-works">
            <span class="nav-icon">
              <svg fill="none" height="20" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                   stroke-width="2" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><circle cx="12"
                                                                                                              cy="12"
                                                                                                              r="10"></circle><circle
                  cx="12" cy="12" r="4"></circle><line x1="4.93" x2="9.17" y1="4.93" y2="9.17"></line><line x1="14.83"
                                                                                                            x2="19.07"
                                                                                                            y1="14.83"
                                                                                                            y2="19.07"></line><line
                  x1="14.83" x2="19.07" y1="9.17" y2="4.93"></line><line x1="14.83" x2="18.36" y1="9.17"
                                                                         y2="5.64"></line><line x1="4.93" x2="9.17"
                                                                                                y1="19.07"
                                                                                                y2="14.83"></line></svg>
            </span>
              How It Works
            </a>
          </div>

          <div [ngClass]="{'visible': mobileMenuOpen}" class="menu-item-container">
            <a (click)="closeMobileMenu()" [class]="'nav-item ' + (isActive('pricing') ? 'active' : '')"
               href="#pricing">
            <span class="nav-icon">
              <svg fill="none" height="20" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                   stroke-width="2" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><circle cx="12"
                                                                                                              cy="12"
                                                                                                              r="10"></circle><line
                  x1="12" x2="12" y1="8" y2="16"></line><line x1="8" x2="16" y1="12" y2="12"></line></svg>
            </span>
              Pricing
            </a>
          </div>

          <div [ngClass]="{'visible': mobileMenuOpen}" class="menu-item-container">
            <a (click)="closeMobileMenu()" [class]="'nav-item ' + (isActive('why-us') ? 'active' : '')" href="#why-us">
            <span class="nav-icon">
              <svg fill="none" height="20" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                   stroke-width="2" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><polygon
                  points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
            </span>
              Why Us
            </a>
          </div>

          <div [ngClass]="{'visible': mobileMenuOpen}" class="menu-item-container">
            <a (click)="closeMobileMenu()" [class]="'nav-item ' + (isActive('song-hub') ? 'active' : '')"
               href="#song-hub">
            <span class="nav-icon">
              <svg fill="none" height="20" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                   stroke-width="2" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path
                  d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16"
                                                                                           r="3"></circle></svg>
            </span>
              Song Hub
            </a>
          </div>

          <div class="menu-divider"></div>

          <div [ngClass]="{'visible': mobileMenuOpen}" class="menu-item-container">
            <a (click)="closeMobileMenu()" class="nav-item" href="https://api.mypart.com/" target="_blank">
            <span class="nav-icon">
              <svg fill="none" height="20" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                   stroke-width="2" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path
                  d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path
                  d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>
            </span>
              API For Developers
            </a>
          </div>
        </div>
      </div>

      <div class="sticky bottom-0 left-0 right-0">
        <div [ngClass]="{'visible': mobileMenuOpen}" class="menu-item-container px-6">
          <a (click)="closeMobileMenu()" class="nav-item api-access" href="https://www.mypart.ai/api-access">
                    <span class="nav-icon">
                      <svg fill="none" height="20" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                           stroke-width="2" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path
                          d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline
                          points="22 4 12 14.01 9 11.01"></polyline></svg>
                    </span>
            Request API Access
            <span class="api-pulse"></span>
          </a>
        </div>

        <!-- TODO: Re-enable when backend is ready for lead gen
        <div *ngIf="!isSignedUp()" [ngClass]="{'visible': mobileMenuOpen}" class="menu-item-container px-6">
          <button (click)="openSignupPopup()"
                  class="nav-item w-full text-center border border-white/20 hover:border-electric-blue/50 rounded-lg transition-all">
            <span class="nav-icon">
              <svg fill="none" height="20" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                   stroke-width="2" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path
                  d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline
                  points="22,6 12,13 2,6"></polyline></svg>
            </span>
            Stay Updated
          </button>
        </div> -->

        <div [ngClass]="{'visible': mobileMenuOpen}" class="menu-item-container px-6">
          <a class="btn-contact w-full" href="https://www.mypart.ai/contact" target="_blank">
            <span class="flex items-center justify-center gap-2">
              <svg fill="none" height="18" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                   stroke-width="2" viewBox="0 0 24 24" width="18" xmlns="http://www.w3.org/2000/svg"><path
                  d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
              Contact Us
            </span>
          </a>
        </div>
        <!-- Social Links -->
        <div [ngClass]="{'visible': mobileMenuOpen}" class="menu-item-container social-links !m-0">
          <div class="flex justify-center gap-6">
            <!-- Add social media icons -->
            <a class="text-white hover:text-electric-blue transition-colors" href="#">
              <svg aria-hidden="true" class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                    d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"></path>
              </svg>
            </a>
            <a class="text-white hover:text-electric-blue transition-colors" href="#">
              <svg aria-hidden="true" class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path clip-rule="evenodd"
                      d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                      fill-rule="evenodd"></path>
              </svg>
            </a>
            <a class="text-white hover:text-electric-blue transition-colors" href="#">
              <svg aria-hidden="true" class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path clip-rule="evenodd"
                      d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
                      fill-rule="evenodd"></path>
              </svg>
            </a>
            <a class="text-white hover:text-electric-blue transition-colors" href="#">
              <svg aria-hidden="true" class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path clip-rule="evenodd"
                      d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.418-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z"
                      fill-rule="evenodd"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <!-- Bottom accent line -->
      <div class="bottom-accent"></div>
    </div>
  </div>
</header>
